import React, { useMemo, useCallback } from 'react';
import Select from 'react-select';

export function PeriodSelect({ SelectorForTeam, activeSelector, setActiveSelector }) {
  const options = useMemo(() => {
    return Object.values(SelectorForTeam).map((value) => {
      return {
        label: value,
        value: value,
      };
    });
  }, [SelectorForTeam]);

  const value = useMemo(() => {
    return activeSelector.value;
  }, [activeSelector]);

  const handleChange = useCallback(
    (value) => {
      setActiveSelector(value.value);
    },
    [setActiveSelector],
  );

  return (
    <Select
      value={value}
      onChange={handleChange}
      options={options}
      styles={{
        control: (base, state) => ({
          ...base,
          borderRadius: '2rem',
          borderColor: state.isFocused ? '#e1343e' : state.isSelected ? '#e1343e' : '#86adc5',
          '&:hover': {
            borderColor: '#e1343e',
          },
          boxShadow: 'none',
          width: '15rem',
          maxWidth: '15rem',
          minHeight: '2.5rem',
          height: '2.5rem',
          paddingLeft: '1rem',
          paddingRight: '1rem',
        }),
        indicatorSeparator: (base) => ({
          ...base,
          display: 'none',
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: '2.5rem',
          display: 'flex',
          alignItems: 'center',
        }),
        menu: (base) => ({
          ...base,
          width: '15rem',
          maxWidth: '15rem',
        }),
        singleValue: (base) => ({
          ...base,
          color: '#86adc5',
          fontSize: '1.2rem',
        }),
        valueContainer: (base) => ({
          ...base,
          display: 'flex',
          alignItems: 'center',
          height: '2.5rem',
          padding: '0 8px',
        }),
        option: (base, state) => ({
          ...base,
          color: state.isSelected ? 'white' : '#86adc5',
          backgroundColor: state.isSelected ? '#e1343e' : 'white',
          fontSize: '1.2rem',
        }),
        placeholder: (base) => ({
          ...base,
          color: '#86adc5',
          fontSize: '1.2rem',
        }),
      }}
    />
  );
}
